import {AxiosError} from 'axios';
import {PUT_UPDATE_CANDIDATE_PROFILE_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutUpdateCandidateProfile = ({onError, onSuccess, uuid}: Input) => {
  const putUpdateCandidateProfile = async (reqBody: any) => {
    const res = await axiosClient.put<void>(PUT_UPDATE_CANDIDATE_PROFILE_URL(uuid), reqBody);

    return res.data;
  };

  return useCustomMutation(putUpdateCandidateProfile, {
    onSuccess,
    onError,
  });
};
